/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import {
  Component, Vue,
} from 'vue-property-decorator';
import { Toast } from '@hb/coffee';
import store from '@/store';
import platform from '@/shared/utils/platform';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { checkWebRTC } from '@/shared/tools/startLiveness/utils';
import { versionCompare } from '@/shared/utils/versionCompare';
import { getIncreaseCreditInfo, getIncreaseCreditContract } from '@/api/increase-credit/increase-credit-zone';
import { IncreaseCreditListType, IncreaseContractType } from '@/api/increase-credit/increase-credit-zone/types';
import { openThirdPage, checkPermission } from '@/api/native/utils';
import { skNativeContainer } from '@/api/native/container';
import { RouterV2Enum } from '@/router/router-names';
import { listerBack } from '@/shared/utils/backListener';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const style: Dictionary = require('./index.module.scss');

// 提额降息专区
const ZoneSumbmitDialog = () => import(
  /* webpackChunkName: "zone-submit-dialog" */'../zone-submit-dialog'
) as any;

@Component
export default class QuotaIncrease extends Vue {
  /** 认证项列表 */
  private authList:IncreaseCreditListType[] = [];

  /** 车抵贷 */
  private carLoanList:IncreaseCreditListType[] = [];


  /** 去确认弹窗展示 */
  private showDialog = false;

  /** 当前去认证项 */
  private currentSelectData?:IncreaseCreditListType;

  /** 当前去认证项协议 */
  private currentDataContract?: IncreaseContractType;

  /** 当前首页展示列表 */
  private get currentList() {
    if (this.authList.length > 0) {
      return this.authList;
    }
    return this.carLoanList;
  }

  /** 去认证 */
  private async goAuthentication(item: IncreaseCreditListType) {
    this.$ubtPageButton('finance_qualityHomePage_increaseCredit_toAuthenticate',
      'dataType',
      item.authId);
    // 以下场景均为app场景下的判断，若后续需要在h5、支付宝小程序中开放入口，则需要做相应的判断处理
    if (item.needFace) {
      const toastMsg = '此认证项需要打开相机权限，请您先开启';
      if (platform.isIOS && !(await checkWebRTC())) {
        Toast(toastMsg);
        return;
      }
      if (platform.isAndroid || platform.isHarmony) {
        const { status } = await checkPermission(2);
        if (!status) {
          Toast(toastMsg);
          return;
        }
      }
    }
    this.currentSelectData = item;
    this.currentDataContract = undefined;
    // 获取去认证项协议
    this.currentDataContract = await getIncreaseCreditContract(item.authId);
    this.showDialog = true;
    this.$ubtModuleExposeNew('finance_qualityHomePage_increaseCredit_confirmPopUp', {});
  }

  /** 查看更多 */
  private goMore() {
    this.$ubtPageButton('finance_qualityHomePage_increaseCredit_more');
    jumpToNewVersion(NewVersionEnum.INCREASE_CREDIT_ZONE, false);
  }

  /** 去申请 */
  private goTarget(item: IncreaseCreditListType) {
    if (item.jumpUrl) {
      this.$ubtPageButton('finance_qualityHomePage_carLoan_apply');
      openThirdPage(item.jumpUrl);
    }
  }

  private onClose() {
    this.showDialog = false;
  }

  private async created() {
    // 目前只做app
    if (platform.isEasyBike) {
      this.getInfo();

      /** 在容器化 或者 钱包tab加载的场景 需要监听页面change事件 刷新组件数据 */
      if (await skNativeContainer() || store.state.base.isHybridAppMode) {
        /** 不能自动取消 需要持续监听 */
        /** 监听app容器切换 */
        listerBack(() => {
          if (HOME_ALL_VERSION_ROUTE_PATHS.includes(this.$route.path as RouterV2Enum)) {
            if (store.state.base.isHybridAppMode && platform.isIOS
              && window.isFinanceTabShow === false) {
              return;
            }
            this.getInfo();
          }
        }, false);
      }
    }
  }

  private async getInfo() {
    const { adjustAuthList = [], carLoanList = [] } = await getIncreaseCreditInfo() || {};
    if (adjustAuthList.length > 0) {
      this.authList = adjustAuthList.slice(0, 2);
      // 认证专区曝光埋点
      this.$ubtModuleExposeNew('finance_qualityHomePage_increaseCredit', {});
      return;
    }
    if (carLoanList.length > 0) {
      this.carLoanList = carLoanList;
      // 车抵贷模块曝光
      this.$ubtModuleExposeNew('finance_qualityHomePage_carLoan', {});
    }
  }

  private render() {
    return (
      (this.authList.length > 0 || this.carLoanList.length > 0) && (
          <div class={style.zone}>
        <div class={style.title}>提额降息专区</div>

        {/* 专区项 */}
        {
          this.currentList.map((item: IncreaseCreditListType) => (
            <div class={style.zoneItem}>
              <img
                src={item.authIcon}
                class={style.image}
              />
              <div class={style.content}>
                <div>{item.authName}</div>
                <div class={style.des}>{item.authIntro}</div>
              </div>
               {/* 认证项按钮 */}
              {this.authList.length > 0 && (
                <div class={style.button} onClick={() => this.goAuthentication(item)}>去认证</div>
              )}
              {/* 车抵贷按钮 */}
              {this.carLoanList.length > 0 && (
                <div class={style.button} onClick={() => this.goTarget(item)}>去申请</div>
              )}
            </div>
          ))
        }

        {/* 查看更多 认证列表才展示查看更多 */}
        {this.authList.length > 0 && (
          <div class={style.more} onClick={this.goMore.bind(this)}>查看更多</div>
        )}

        <ZoneSumbmitDialog
          dialogShow={this.showDialog}
          data={this.currentSelectData}
          contractList={this.currentDataContract}
          onClose={this.onClose.bind(this)}
        />
      </div>
      )
    );
  }
}
